<template>
  <div :class="gameItemClass">
    <div :class="resultHeaderClass">
      <div class="flex-width text-left">
        {{ title }}
      </div>
      <div class="flex-width text-right">
        {{ roundRead }}
      </div>
    </div>
    <div :class="gameItemBodyClass">
      <div class="flex-width text-center border-right">
        <p class="text-gray-500 px-0 py-0 my-0 mx-0 text-md">
          สามตัวบน
        </p>
        <p class="text-dark px-0 py-0 my-0 mx-0 text-lg">
          {{ digitUpper }}
        </p>
      </div>
      <div class="flex-width text-center">
        <p class="text-gray-500 px-0 py-0 my-0 mx-0 text-md">
          สองตัวล่าง
        </p>
        <p class="text-dark px-0 py-0 my-0 mx-0 text-lg">
          {{ digitUnder }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ResultItem',
  props: {
    title: { type: String, default: '' },
    roundRead: { type: String, default: '' },
    digitAnyUpper: { type: String, default: 'รอผล' },
    digitAnyUnder: { type: String, default: 'รอผล' },
    digitTwoUpper: { type: String, default: 'รอผล' },
    digitTwoUnder: { type: String, default: 'รอผล' },
    digitThreeFront: { type: String, default: 'รอผล' },
    digitThreeBack: { type: String, default: 'รอผล' },
    digitTreeUpper: { type: String, default: 'รอผล' },
    digitTreeShuffle: { type: String, default: 'รอผล' },
    closeAt: { type: String, default: '' },
    // secondsLeft: { type: Number, default: 0 },
    // gameLink: { type: String, default: '#' },
    status: { type: String, default: 'open' },
  },

  data() {
    return {
      linkLabel: 'แทง',
      gameItemClass: 'card shadow-sm text-success',
      gameItemHeaderClass:
        'card-header text-xl text-monospace bg-success text-white text-center d-flex',
      gameItemBodyClass: 'card-body d-flex py-3',
    };
  },

  computed: {
    resultHeaderClass() {
      if (this.digitUpper != 'รอผล') {
        return (this.gameItemHeaderClass = 'card-header text-xl text-monospace bg-success text-white text-center d-flex');
      }
      return (this.gameItemHeaderClass = 'card-header text-xl text-monospace bg-primary text-white text-center d-flex');

      if (this.status == 'close') {
        return (this.gameItemHeaderClass = 'card-header text-xl text-monospace bg-gray-500 text-white text-center d-flex');
      }
    },
  },

  mounted() {
    if (this.secondsLeft <= 0) {
      this.linkLabel = 'รอประกาศผล';
      this.gameItemClass = 'card shadow-sm shadow';
      this.gameItemHeaderClass = 'card-header text-xl text-monospace text-dark text-center d-flex';
      this.gameItemBodyClass = 'card-body d-flex py-3 bg-primary text-white';
    }
    if (this.status == 'closed') {
      this.linkLabel = 'ปิดรับแทง';
      this.gameItemClass = 'card shadow-sm bg-gray-500 text-white';
      this.gameItemHeaderClass = 'card-header text-xl text-monospace bg-gray-500 text-white text-center d-flex';
      this.gameItemBodyClass = 'card-body d-flex py-3 bg-gray-600';
    }
  },

  methods: {
    gameTimeout() {
      this.linkLabel = 'รอประกาศผล';
      this.gameItemClass = 'card shadow-sm shadow';
      this.gameItemHeaderClass = 'card-header text-xl text-monospace text-dark text-center d-flex';
      this.gameItemBodyClass = 'card-body d-flex py-3 bg-primary text-white';
    },
  },
};
</script>
